import { render } from "./SlackChannelBox.vue?vue&type=template&id=152953e2"
import script from "./SlackChannelBox.vue?vue&type=script&lang=js"
export * from "./SlackChannelBox.vue?vue&type=script&lang=js"

import "./SlackChannelBox.vue?vue&type=style&index=0&id=152953e2&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__